require('../common/jv.common.parse-querystring.service');

angular.module('jv.register.sendInvitation.controller', [
    'jv.common.parse-querystring.service'
    ])

    .controller('jvSendInvitationController', ['$scope', 'jvRegistrationSVC','$log','parseQuerystring','$window',
        function ($scope,jvRegistrationSVC, $log, parseQuerystring, $window) {
            $scope.flags = $scope.flags || {};
            $scope.flags.loading = false;
            var queryStringAsObject = parseQuerystring($window.location.search);
            $scope.invite = {
                sent: false,
                urlEId: queryStringAsObject['urlEId']
            };

            $scope.send = function(){
                $scope.flags.loading = true;
                jvRegistrationSVC.sendInvitationLink($scope.invite.urlEId, function(response){
                    if(response){
                        $scope.invite.email = response;
                        $scope.invite.sent = true;
                    }else{
                        $log.info('Send Invitation: Response is empty.');
                        $window.location.href = '/admin/info/inconsistency.html';
                    }
                    $scope.flags.loading = false;
                }, function(err){
                    $log.error(err);
                    $scope.flags.loading = false;
                });
            };
        }
    ]);